document.addEventListener("DOMContentLoaded", function () {
  // --- SCRIPT 1: SVGs ---
  document.querySelectorAll("svg").forEach(function (svg) {
    if (!svg.hasAttribute("role")) {
      svg.setAttribute("role", "presentation");
    }
  });

  // --- SCRIPT 2: Botones accesibles ---
  const buttonClasses = ["grp-slider-prev", "grp-slider-next", "grp-dot", "dot"];

  function applyButtonRoles(root = document) {
    buttonClasses.forEach(function (className) {
      root.querySelectorAll("." + className).forEach(function (el) {
        if (!el.hasAttribute("role")) {
          el.setAttribute("role", "button");
        }
        if (!el.hasAttribute("aria-label")) {
          el.setAttribute("aria-label", "Navigation Google Reviews");
        }
      });
    });
  }

  // Aplica en el DOM inicial
  applyButtonRoles();

  // --- OBSERVADOR ---
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList.contains("grp-entangle--root")) {
          applyButtonRoles(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // --- FALLBACK: setInterval ---
  const interval = setInterval(() => {
    const widgetRoot = document.querySelector(".grp-entangle--root");
    if (widgetRoot) {
      applyButtonRoles(widgetRoot);
      clearInterval(interval); // deja de buscar una vez que lo encuentra
    }
  }, 500);
});
